'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	getEventDescription = require('./get-event-description'),
	isEventEphemeral = require('./is-event-ephemeral'),
	getEventContextNode = require('./get-event-context-node'),
	content = require('@mindmup/mapjs-core/src/content/content');

module.exports = function HistoryModel(params) {
	const obj = observable(this),
		{collaborationModel, navigatorShim, maxInitialEvents} = params;
	if (!collaborationModel || !navigatorShim || !maxInitialEvents) {
		throw new Error('invalid-args');
	}
	let serializedHistoricalInitialContent, historicalEvents, localSessionId;

	obj.restoreUpTo = function (eventIndex) {
		if (!historicalEvents) {
			throw new Error('history model not initialised');
		}

		obj.dispatchEvent('restoringHistory');
		return new Promise((resolve) => {
			navigatorShim.setTimeout(() => {
				collaborationModel.initializeSession(collaborationModel.getLocalSessionId(), JSON.parse(serializedHistoricalInitialContent), historicalEvents.slice(0, eventIndex + 1));
				resolve();
			}, 100);
		})
		.then(() => obj.dispatchEvent('activeIndex', eventIndex));

	};
	obj.getEventCount = function () {
		return historicalEvents.length;
	};
	obj.getEventSummary = function (index) {
		const historicalEvent = historicalEvents && historicalEvents[index],
			description = historicalEvent && getEventDescription(historicalEvent.cmd, historicalEvent.args);
		if (!historicalEvent) {
			return false;
		}
		return {
			index: index,
			collaborator: historicalEvent.collaborator?.displayName,
			ts: historicalEvent.ts,
			description,
			nodeId: getEventContextNode(historicalEvent.cmd, historicalEvent.args),
			ephemeral: !description || isEventEphemeral(historicalEvent.cmd, historicalEvent.args)
		};
	};
	collaborationModel.addEventListener('newSession', (activeContent, sessionId, initialContent, initialEvents) => {
		if (!localSessionId) {
			const maxVisible = Math.max(initialEvents.length - maxInitialEvents, 0),
				watermarkBytes = activeContent && activeContent.attr && activeContent.attr['watermark-bytes'],
				preHistoricalEvents = initialEvents.slice(0, maxVisible);
			historicalEvents = initialEvents.slice(maxVisible);
			serializedHistoricalInitialContent = JSON.stringify(content(initialContent, sessionId, preHistoricalEvents));
			localSessionId = sessionId;
			obj.dispatchEvent('newSession');
			if (historicalEvents.length) {
				obj.dispatchEvent('eventCount', historicalEvents.length);
				obj.dispatchEvent('activeIndex', historicalEvents.length - 1);
			}
			obj.dispatchEvent('hasWatermark', !!watermarkBytes);
		}
	});
	collaborationModel.addEventListener('localContentEvent remoteContentEvent', (contentEvent, sessionId) => {
		const collaborator = sessionId ? (contentEvent.collaborator || {sessionId}) : {displayName: 'You', sessionId: localSessionId},
			contentEventClone = Object.assign({ts: Date.now(), collaborator: collaborator}, contentEvent);
		historicalEvents.push(contentEventClone);
		obj.dispatchEvent('eventCount', historicalEvents.length);
	});
};
